'use strict';

angular.module('atex.dam').controller('DamJobsViewController',
  ['$scope','$rootScope', '$timeout','$window', 'DamTaskService', '$translate', 'configuration', 'ContentService',
function($scope, $rootScope, $timeout, $window, DamTaskService, $translate, configuration, ContentService) {
  $scope.timeouts = [];

  $translate(['__GENERIC_ERROR_MSG__', '_ARTICLE_LENGTH_LABEL_', '_MEASUREMENT_UNIT_LABEL']).then(function (translations) {
    $scope.message = {};

    $scope.message.length = translations._ARTICLE_LENGTH_LABEL_;
    $scope.message.unit = translations._MEASUREMENT_UNIT_LABEL;
  });

  configuration.getPublishingScheduleEnabled().then(function (value) {
    $scope.useList = value;
  });

  $rootScope.$on("dam:logout", function () {
    $scope.timeouts = [];
  });

  $rootScope.$on("onecms:authenticationSuccess", function () {
    $scope.timeouts = [];
  });

  $scope.tasks = function (job) {
    return atex.onecms.ObjectUtils.getByPath(job._data.aspects, 'contentData/data/objects') || [];
  };

  function contains(id) {
    return (getTimeoutIndex(id) > -1);
  }

  function getTimeoutIndex(id) {
    var key = -1;

    angular.forEach($scope.timeouts, function (timeout, index) {
      if (timeout.id === id) {
        key = index;
      }
    });

    return key;
  }

  function updateSelection(tasks) {
    tasks.map(function (task) {
      if ($scope.selected) {
        $scope.selected.forEach(function (selection, key) {
          if (selection.id === task.id) {
            $scope.selected[key] = task;
          }
        });
      }
    });
  }

  function cancel(id) {
    if (contains(id)) {
      var index = getTimeoutIndex(id);
      var timeout = $scope.timeouts[index].timeout;

      if (timeout) {
        $timeout.cancel(timeout);
      }

      $scope.timeouts.splice(index, 1);
    }
  }

  function cancelAll() {
    if ($scope.timeouts) {
      $scope.timeouts.forEach(function (timeout) {
        $timeout.cancel(timeout.timeout);
        timeout.job.show = false;
      });

      $scope.timeouts = [];
    }
  }

  $scope.$on("dam:updatedItem", function(event, asset) {
    if (!asset || !asset.id || !$scope.entries) {
      return;
    }

    $scope.entries.forEach(function (entry, i) {
      if (entry.id === asset.id) {
        var variant = ($scope.physPage) ? 'ppage' : 'preview';
        ContentService.getContent({id: asset.id, variant: variant}).then(function (response) {
          atex.dam.AngularUtils.fixUrls(response.data);
          angular.copy(response.data, entry._data);
        });
      }
    });
  });

  var poll = function (job) {
    if (job.show) {
      var tasks = atex.onecms.ObjectUtils.getByPath(job, '_data/aspects/contentData/data/tasks') || [];

      DamTaskService.tasks(tasks).then(function (results) {
        job._data.aspects.contentData.data.objects = results;
        updateSelection(results);
      });

      var timeout = $timeout(function () {
        poll(job);
      }, 15000);

      cancel(job.id);
      var content = {timeout: timeout, id: job.id, job: job};
      if (!contains(job.id)) {
        $scope.timeouts.push(content);
      } else {
        $scope.timeouts[getTimeoutIndex(job.id)] = content;
      }
    }
  };

  $scope.show = function (job) {
    job.show = true;
    poll(job);
  };

  $scope.label = function (length) {
    var message = 'Not defined';

    if (length) {
      message = ($scope.message.length + ':' + length + ' ' + $scope.message.unit);
    }

    return message;
  };

  $scope.hasMoreElements = function (job) {
    if (!job.show) {
      cancel(job.id);
    }

    var tasks = atex.onecms.ObjectUtils.getByPath(job._data.aspects, 'contentData/data/tasks') || [];
    return (tasks.length > 0);
  };

  $scope.hide = function (job) {
    job.show = false;
    cancel(job.id);
  };

  var onBeforeUnloadFn = function () {
    cancelAll();
  };

  $window.onbeforeunload = onBeforeUnloadFn;

  $scope.$on('$destroy', function () {
    $window.onbeforeunload = undefined;
  });

  $scope.$on("dam:view-change", function (event, id) {
    if ((id) && (id !== 'jobs')) {
      cancelAll();
    }
  });

  $rootScope.$on('$stateChangeStart', function () {
    cancelAll();
  });
}]);